import { gsap, ScrollTrigger } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade } from 'swiper/modules';

// matchheight
import {matchHeight} from '../matchHeight';

function threatCard() {
    const threatCard = document.querySelectorAll('.threat__card');

    threatCard.forEach((item) => {
        let cardTitle = item.querySelector('.threat__card-title');
        let threatTypeDescription = item.querySelector('.threat__card-type-description');
        let threatTypeDescriptionHeight = threatTypeDescription.offsetHeight;
        
        if (window.innerWidth > 1024) {
            let topFrom = `${threatTypeDescriptionHeight}`;
            let bottomFrom = -`${threatTypeDescriptionHeight}`;
            
            
            let animation = gsap.timeline();
            animation.fromTo(cardTitle, {
                top: topFrom,
                color: '#ffffff',
            }, {
                top: 0,
                color: '#0a0b0a',
            })
            .fromTo(threatTypeDescription, {
                bottom: bottomFrom,
                autoAlpha: 0,
            }, {
                bottom: 0,
                autoAlpha: 1,
            }, '-=0.5');
            animation.pause();
    
            item.addEventListener("mouseenter", (event) => {
                animation.play();
            })
            item.addEventListener("mouseleave", (event) => {
                animation.reverse();
            })
        } else if(window.innerWidth <= 1024) {
            item.addEventListener('click', (elClosed) => {
                threatCard.forEach((el) => {
                    el.classList.remove('show');
                })
                
                if(elClosed.target.classList.contains('threat__card-close-wrapper') || elClosed.target.classList.contains('threat__card-close')) {
                    let cardClosed = elClosed.target.parentNode.parentNode;
                    cardClosed.classList.remove('show');
                } else {
                    item.classList.add('show');
                }
            })
        }
    })

    // match height card
    const cardOverlay = document.querySelectorAll('.threat__card-overlay');
    matchHeight(cardOverlay);    
}

function donationSection() {
    const donationSection = document.querySelector(".donation");
    const donationWrapper = document.querySelector(".donation__wrapper");

    let mm = gsap.matchMedia()
    mm.add("(min-width: 992px)", () => {
        ScrollTrigger.create({
            trigger: donationSection,
            pin: donationWrapper,
            start: "top+=5% top",
            end: "bottom-=13% bottom",
            // markers: true
        });
    })
}

document.addEventListener('DOMContentLoaded', () => {
    threatCard();
    donationSection();
})

window.addEventListener('resize', () => {
    threatCard();
})